import React from 'react';

const Maps = () => {
    return (
        <div>
            this is map
        </div>
    );
};

export default Maps;